
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Nationality extends Vue {
  @Prop() readonly value: string = "";
  @Prop() readonly isSavingProfile: boolean = false;
}
